import { CircularProgress } from "@mui/material";
import { FC } from "react";
import styles from '../fallback/fallback.module.scss';

const Fallback : FC = () => {
    return (
        <main className={styles.fallbackMain}>
            <CircularProgress color="inherit"/>
        </main>
    )
}

export default Fallback